import { useEffect, useState } from 'react';
import { Select, Skeleton } from '@backstage/ui';

const MultiSelect = Select as any;
import {
  FieldExtensionComponentProps,
} from '@backstage/plugin-scaffolder-react';
import { catalogApiRef } from '@backstage/plugin-catalog-react';
import { useApi } from '@backstage/core-plugin-api';
import { Entity } from '@backstage/catalog-model';

export const MultiUserSelectField = ({ 
    formData, onChange, schema}: FieldExtensionComponentProps<string[]>) => {
    const catalogApi = useApi(catalogApiRef);
    const label = schema.title ?? 'Users';
    const [options, setOptions] = useState<
      { label: string; id: string }[] | undefined
    >();

    // Load Components (kind=User)
    useEffect(() => {
      const load = async () => {
        const items: Entity[] = [];

        const resp = await catalogApi.getEntities({
          filter: { kind: 'User' },
          fields: [
            'metadata.name',
            'metadata.namespace',
            'spec.profile.displayName',
          ],
          limit: 500,
        });

        items.push(...resp.items);
        setOptions(
          items            
            .map(e => ({
              label: (typeof e.spec === 'object' && e.spec && 'profile' in e.spec && typeof (e.spec as any).profile === 'object'
                ? (e.spec as any).profile?.displayName
                : undefined) ?? e.metadata.name,
              id: `User:${e.metadata.namespace ?? 'default'}/${e.metadata.name}`,
            })),
        );
      };
      load();
    }, [catalogApi]);

    if (!options) {
      return <Skeleton />;
    }

    return (
      <MultiSelect
        label={label}
        selectionMode="multiple"
        selectedKeys={new Set(formData ?? [])}
        onSelectionChange={(keys: Set<string>) => onChange(Array.from(keys))}
        options={options}
      />
    );
  };
